import React from 'react'
import { useSelector } from 'react-redux'
import { FieldArray } from 'formik'
import { find } from 'lodash'
import { NavLink } from 'react-router-dom'

import Select from 'components/Forms/Select'
import { DateTimePicker } from '.'
import { hasAccessToThis } from 'services/Utilities'
import { Card } from 'ui'

import { t } from 'translations'

import { Button as MerinioButton } from 'ui'

const ClientSeniority = ({ name = 'clientSeniorities', module = 'manager.users.form', clientSeniorities, disabled }) => {
  const { tags } = useSelector(state => state.resources)
  const tagManage = hasAccessToThis('tagManage')

  // Filter clients that are already added to the user
  const clients = tags.filter(tag => tag.type === 'clients')
  const availableClients = clients.filter(client => !find(clientSeniorities, { clientId: client._id }))

  return (
    <>
      <h5>{t(`${module}.${name.toUpperCase()}.TITLE`)}</h5>
      <small className="form-text text-muted">{t(`${module}.${name.toUpperCase()}.DESCRIPTION`)}</small>
      {!clients.length ? (
        <div className="mb-4">
          {tagManage ? (
            <>
              {t('components.addResource.NO_RESOURCES')}
              <div>
                <NavLink to={'/admin/tags'}>{t('components.addResource.ADD_RESOURCES')}</NavLink>
              </div>
            </>
          ) : (
            <>
              {t('components.addResource.NO_RESOURCES')} {t('components.addResource.NO_PERMISSION')}
            </>
          )}
        </div>
      ) : (
        <FieldArray
          name={name}
          render={arrayHelpers => (
            <Card className="bg-light mb-3">
              <div className="p-3">
                {clientSeniorities.map((client, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="d-md-flex">
                        <div className="flex-grow-1 mr-md-2">
                          <Select
                            module={'manager.users.form.CLIENTSENIORITIES'}
                            name={`${name}[${index}].clientId`}
                            required
                            translation="clientId"
                            options={clients.map(({ _id, name }) => ({ _id, name }))}
                          />
                        </div>
                        <div className="flex-grow-1 mr-md-2">
                          <DateTimePicker
                            module="manager.users.form.CLIENTSENIORITIES"
                            translation="seniorityDate"
                            name={`${name}[${index}].seniorityDate`}
                            required
                            type="date"
                          />
                        </div>

                        <div style={{ marginTop: '32px' }}>
                          <MerinioButton type="button" color="secondary" onClick={() => arrayHelpers.remove(index)} outlined>
                            <i className="fas fa-trash" />
                          </MerinioButton>
                        </div>
                      </div>
                      {index !== clientSeniorities.length - 1 ? <hr /> : null}
                    </React.Fragment>
                  )
                })}
                {!disabled ? (
                  <MerinioButton
                    type="button"
                    color="secondary"
                    className=" mt-3"
                    onClick={() => arrayHelpers.push({ clientId: availableClients[0]._id, seniorityDate: new Date() })}
                    outlined
                  >
                    <i className="fas fa-plus" />
                  </MerinioButton>
                ) : null}
              </div>
            </Card>
          )}
        />
      )}
    </>
  )
}

export default ClientSeniority
